import { useState, useEffect } from 'react'
import axios from 'axios'

export function useTemplates(companyId) {
  const [templates, setTemplates] = useState([])

  useEffect(() => {
    if (!companyId) return

    async function fetchTemplates() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_URL_API}/api/v1/crm/templates/${companyId}`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
          }
        )
        setTemplates(data.templates || [])
      } catch (err) {
        console.error("Erro ao carregar templates:", err)
        setTemplates([])
      }
    }

    fetchTemplates()
  }, [companyId])

  return {
    templates
  }
}